export default function initPagesCarousel(Swiper, Navigation, Autoplay) {
    // ==========================================================
    // PAGES CAROUSEL
    // ==========================================================

    const pagesCarousels = document.querySelectorAll("[data-pages-carousel]");

    pagesCarousels.forEach((slider) => {
        const section = slider.closest(".pages-carousel");

        if (!section) {
            return;
        }

        const prev = section.querySelector("[data-pages-carousel-prev]");

        const next = section.querySelector("[data-pages-carousel-next]");

        new Swiper(slider, {
            modules: [Navigation, Autoplay],
            loop: true,
            watchOverflow: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            slidesPerView: 1.2,
            spaceBetween: 16,

            navigation: {
                prevEl: prev,
                nextEl: next,
            },

            breakpoints: {
                640: {
                    slidesPerView: 1.8,
                    spaceBetween: 18,
                },

                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                },

                1024: {
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                },

                1280: {
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                },

                1440: {
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                },
            },
        });
    });
}
